import React, { Fragment } from 'react';

import useNextDelivery from '../hooks/useNextDelivery/useNextDelivery';
import useDeliveryCutOffCountDown from '../hooks/useDeliveryCutOffCountDown/useDeliveryCutOffCountDown';

type Props = Pick<ReturnType<typeof useNextDelivery>, 'cutOffTime' | 'refetch'>

const CountDownDisplay = ({ cutOffTime, refetch }: Props) => {
    const timeRemaining = useDeliveryCutOffCountDown({ cutOffTime, onCountDownEnd: refetch });

    return <Fragment>{timeRemaining}</Fragment>;
};

export default CountDownDisplay;
